<template>
  <v-col class="py-0">
    <v-row no-gutters>
      <v-col class="pa-1 pl-0">
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">លេខកូដសាលា</span><br />
              <span class="font-weight-regular">{{ info.scod }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col class="pa-1">
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ឈ្មោះរាជធានី ខេត្ត</span><br />
              <span class="font-weight-regular">{{ info.proKH }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col class="pa-1">
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ឈ្មោះក្រុង ស្រុក ខណ្ឌ</span><br />
              <span class="font-weight-regular">{{ info.disKH }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col class="pa-1 pr-0">
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ឈ្មោះឃុំ សង្កាត់</span><br />
              <span class="font-weight-regular">{{ info.comKH }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col class="pa-1 pl-0 pt-0">
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ឈ្មោះសាលា</span><br />
              <span class="font-weight-regular">{{ info.schKH }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col class="pa-1 py-0">
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ឈ្មោះនាយក</span><br />
              <span class="font-weight-regular">{{
                info.principal_name_kh
              }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col class="pa-1 py-0">
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ឈ្មោះសាលា</span><br />
              <span class="font-weight-regular">{{ info.schENG }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col class="pa-1 pr-0 pt-0">
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ទូរស័ព្ទ</span><br />
              <span class="font-weight-regular">{{ info.pho_num }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
  <!--
  <v-container class="pa-0 my-1">
    <v-layout row>
      <v-flex xs12 sm6 md3>
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">លេខកូដសាលា</span><br />
              <span class="font-weight-regular">{{ info.scod }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 md3>
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ឈ្មោះរាជធានី ខេត្ត</span><br />
              <span class="font-weight-regular">{{ info.proKH }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 md3>
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ឈ្មោះក្រុង ស្រុក ខណ្ឌ</span><br />
              <span class="font-weight-regular">{{ info.disKH }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 md3>
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ឈ្មោះឃុំ សង្កាត់</span><br />
              <span class="font-weight-regular">{{ info.comKH }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 md3>
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ឈ្មោះសាលា</span><br />
              <span class="font-weight-regular">{{ info.schKH }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 md3>
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ឈ្មោះសាលា</span><br />
              <span class="font-weight-regular">{{ info.schENG }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 md3>
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ឈ្មោះនាយក</span><br />
              <span class="font-weight-regular">{{
                info.principal_name_kh
              }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 md3>
        <v-card color="#1F7087" dark>
          <v-card-title class="py-0">
            <div>
              <span class="font-weight-bold">ទូរស័ព្ទ</span><br />
              <span class="font-weight-regular">{{ info.pho_num }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  -->
</template>
<script>
export default {
  name: "SchoolInfo",
  props: ["info"],
};
</script>